import styled from 'styled-components';

const ContactUs = styled.p`
  line-height: normal;
  margin-bottom: 0;

  small {
    font-weight: ${props => props.theme.fontBold};
    text-transform: uppercase;
  }
`;

export default ContactUs;
